<div class="container-fluid px-0">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center breadcrumb">
    <!-- Breadcrumb Section -->
    <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>

    <!-- Action Button Group -->
    <div class="d-flex align-items-center gap-2 buttons-part">
      <!-- Action buttons can be added here as needed -->
    </div>
  </div>

  <!-- Filter Section -->
  <div class="section-card mt-3">
    <div class="section-header d-flex justify-content-between align-items-center">
      <h6 class="section-title">
        <i class="fas fa-filter me-2"></i> Filter
      </h6>
      <div style="cursor: pointer;" (click)="isFilterVisible = !isFilterVisible">
        <i class="fa" [ngClass]="isFilterVisible ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </div>
    </div>
    <div class="section-body" *ngIf="isFilterVisible">
      <div class="row">
        <div class="col-md-4">
          <label class="form-label">System Roles</label>
          <mat-form-field appearance="outline" class="w-100">
            <mat-select [(ngModel)]="selectedRoles" multiple placeholder="All Roles"
              (selectionChange)="onRoleSelectionChange($event)">
              <mat-option [value]="'all'">All System Roles</mat-option>
              <mat-option *ngFor="let role of roles" [value]="role.name">{{ role.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="selectedStatus">
            <option value="">All</option>
            <option value="active">Active</option>
            <option value="disabled">Disabled</option>
          </select>
        </div>
      </div>
      <div class="text-end mt-3">
        <button class="btn btn-primary me-2" type="button" (click)="applyFilters()">Apply</button>
        <button class="btn btn-secondary" type="button" (click)="clearFilters()">Clear</button>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="search-box">
      <div class="input-group">
        <span class="input-group-text">
          <i class="fas fa-search text-muted"></i>
        </span>
        <input type="text" class="form-control" placeholder="Search user here" [(ngModel)]="globalSearchTerm"
          (ngModelChange)="onSearchChange($event)" #searchInput>
        <button class="btn btn-outline-danger" type="button" (click)="clearSearch()"
          *ngIf="globalSearchTerm && globalSearchTerm.trim() !== ''">
          Clear
        </button>
      </div>
    </div>
    <!-- Mobile: collapse the toolbar into an "Actions" dropdown (<= 768px) -->
    <div class="dropdown mobile-actions-dropdown">
      <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        Actions
      </button>
      <div class="dropdown-menu dropdown-menu-end p-2 mobile-actions-menu">
        <div class="d-flex flex-column gap-2">
          <button (click)="onClearAllFilters()" class="btn btn-secondary" title="Clear All Filters">
            Clear All Filters
          </button>
          <button class="btn btn-primary" (click)="addUser()">
            <i class="fas fa-plus me-1"></i> Add User
          </button>
        </div>
      </div>
    </div>

    <!-- Desktop / tablet: original inline toolbar (unchanged) -->
    <div class="d-flex align-items-center gap-2 desktop-actions">
      <button (click)="onClearAllFilters()" class="btn btn-secondary" title="Clear All Filters">
        Clear All Filters
      </button>
      <button class="btn btn-primary" (click)="addUser()">
        <i class="fas fa-plus"></i>
        Add User
      </button>
    </div>
  </div>
  <div class="resizable-container">
    <div class="resizable-panel grid-panel" [style.width.%]="100">
      <div class="ag-theme-alpine" style="height: 100%; width: 100%;">
        <ag-grid-angular #agGrid  [columnDefs]="columnDefs" [rowData]="rowData" [defaultColDef]="defaultColDef"
          [components]="components" [context]="gridContext" [gridOptions]="gridOptions" [pagination]="true"
          [paginationPageSize]="environment.paginationPageSize"
          [paginationPageSizeSelector]="environment.paginationPageSizeSelector" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
    </div>
  </div>

  <!-- Assigned Information Popup -->
  <div class="assigned-info-backdrop" *ngIf="showAssignedInfo" (click)="closeAssignedInfo()"
    style="position:fixed; inset:0; z-index:2000;">
    <div class="assigned-info-popup" (click)="$event.stopPropagation()"
      [style.top.px]="assignedInfoPosition.top"
      [style.left.px]="assignedInfoPosition.left"
      [style.transform]="assignedInfoOpenAbove ? 'translateY(-100%)' : 'none'"
      style="position:fixed; background:var(--card-bg, #fff); color:var(--font-color, #333); border-radius:8px; box-shadow:0 4px 20px rgba(0,0,0,0.25); width:450px; max-width:90vw; max-height:320px; z-index:2001; border:1px solid var(--border-color, #dee2e6); overflow:hidden; display:flex; flex-direction:column;">
      <div style="display:flex; justify-content:space-between; align-items:center; padding:10px 14px; border-bottom:1px solid var(--border-color, #dee2e6); background:var(--ag-header-background-color, #f8f9fa);">
        <h6 class="mb-0" style="font-size:15px; font-weight:600; color:var(--font-color, #333);">Assigned Information</h6>
        <span style="cursor:pointer; font-size:20px; line-height:1; color:var(--font-color, #333);" (click)="closeAssignedInfo()">&times;</span>
      </div>
      <div *ngIf="assignedInfoUser" style="padding:12px 14px; max-height:300px; overflow-y:auto;">
        <div class="row">
          <div class="col-6">
            <h6 style="font-size:14px; font-weight:700; text-decoration:underline; margin-bottom:6px; color:var(--font-color, #333);">Customers</h6>
            <ul style="list-style:none; padding:0; margin:0; font-size:13px; color:var(--font-color, #333);" *ngIf="getUniqueCustomers(assignedInfoUser.locations).length > 0; else noCustomers">
              <li *ngFor="let c of getUniqueCustomers(assignedInfoUser.locations)" style="margin-bottom:3px; word-break:break-word;">• {{ c }}</li>
            </ul>
            <ng-template #noCustomers><p style="font-size:13px; color:var(--font-color, #999);">No customers assigned</p></ng-template>
          </div>
          <div class="col-6">
            <h6 style="font-size:14px; font-weight:700; text-decoration:underline; margin-bottom:6px; color:var(--font-color, #333);">Locations</h6>
            <ul style="list-style:none; padding:0; margin:0; font-size:13px; color:var(--font-color, #333);" *ngIf="getUniqueLocations(assignedInfoUser.locations).length > 0; else noLocations">
              <li *ngFor="let l of getUniqueLocations(assignedInfoUser.locations)" style="margin-bottom:3px; word-break:break-word;">• {{ l }}</li>
            </ul>
            <ng-template #noLocations><p style="font-size:13px; color:var(--font-color, #999);">No locations assigned</p></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>